export const calc = (am1, am2, type='add') => {
    let a1 = parseFloat(am1)
    let a2 = parseFloat(am2)
    if(type === 'add') {
        return a1 + a2
    }
    if(type === 'sub'){
        return a1 - a2
    }
    return "e"
}

export const fMon = (am) => {
    if(am === 0) return "$0.00"
    if(!parseFloat(am)) {
        return '--'
    }
    return `$${(Math.round(am * 100) / 100).toFixed(2)}`
}